import React from 'react';
import './ValidationResponse.css';

function ValidationResponse({ validationResult, isLoading }) {

  // Helper function to render document information
  const renderInformation = (information) => {
    if (!information || information.length === 0) return null;

    return (
      <div className="mt-4">
        <h4 className="text-sm font-semibold mb-2">Extracted Information</h4>
        <div className="content">
          <ul>
            {information.map((item, index) => (
              <li key={index}>
                <strong>{item.type}:</strong> {item.data}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  // Helper function to render issues
  const renderIssues = (issues) => {
    if (!issues || issues.length === 0) return null;

    return (
      <div className="mt-3">
        <h4 className="text-sm font-semibold mb-2">Identified Issues</h4>
        <div className="content">
          <ul>
            {issues.map((issue, index) => (
              <li key={index}>{issue}</li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="box validation-response-box">
      <div className="has-text-centered mb-4">
        <h2>Results</h2>
      </div>

      {isLoading ? (
        <div className="loading-indicator">
          <i className="fas fa-spinner"></i>
          <span>Loading...</span>
        </div>
      ) : validationResult ? (
        <div className="result-content">
          <div className="result-header">
            <div className="document-type">
              <span className="tag is-dark">
                {validationResult.documentType || "Document"}
              </span>
              {validationResult.accuracyOfData && (
                <span className="tag is-light">
                  Accuracy: {(validationResult.accuracyOfData * 100).toFixed(1)}%
                </span>
              )}
            </div>
          </div>

          {validationResult.comment && (
            <div className="comment mb-4">
              <p>{validationResult.comment}</p>
            </div>
          )}

          {renderIssues(validationResult.issues)}
          {renderInformation(validationResult.information)}
        </div>
      ) : (
        <div className="empty-state">
          <i className="fas fa-file-shield fa-2x mb-3"></i>
          <p>No document uploaded</p>
        </div>
      )}

      {/* Footer info removed as we now have a main footer */}
    </div>
  );
}

export default ValidationResponse;
